import React from 'react';
import {withTranslation} from 'react-i18next';
import {Form as FinalForm} from 'react-final-form';
import {Button, Col, Form, Row} from 'reactstrap';
import TextField from '../components/TextField';
import LoaderButton from '../components/LoaderButton';
import ModalManager from '../components/modal/ModalManager';
import {NotificationManager} from '../components/common/react-notifications';
import getBank from "../helpers/detectBank";
import Api from '../services/Api';


class BankAccountFormV2 extends React.Component {
  createBankAccount = async values => {
    const {t, type, userId} = this.props;
    try {
      await Api.invoke(
        'POST',
        `/v2/admin-ui/user-bank-account/${type}`,
        {
          ...values,
          userId,
          title: values.title || this.getBankName(type, values),
        },
      );
      NotificationManager.success(
        type === "iban" ? t('Iban number added successfully') : t('Card number added successfully'),
        t('Message')
      );
      ModalManager.close({
        isOpen: false
      });
      this.props.fireFetchData();
    } catch (e) {
      if (e.fieldError) {
        return e.fieldError;
      }
      throw e;
    }
  };

  getBankName = (type, values) => {
    const {iban, cardNumber} = values;
    if (type === "card-number") {
      return getBank("card_no", cardNumber.slice(0, 6))["bank_title"];
    }
    return getBank("iban_no", iban.slice(2, 5))["bank_title"];
  }

  render() {
    const {t, type} = this.props;
    return(
      <FinalForm
        onSubmit={this.createBankAccount}
        render={({handleSubmit, submitting, pristine, hasValidationErrors}) => {
          return (
            <Form>
              <Row>
                <Col>
                  <TextField item={{
                    name: 'title',
                    i18n: t('Title'),
                    type: 'text',
                  }}/>
                </Col>
              </Row>
              {type === "card-number" &&
                <Row>
                  <Col>
                    <TextField item={{
                      name: 'cardNumber',
                      i18n: t('Card Number'),
                      type: 'text',
                      required: true,
                      format: '####-####-####-####',
                    }}/>
                  </Col>
                </Row>
              }
              {type === "iban" &&
                <Row>
                  <Col>
                    <TextField item={{
                      name: 'iban',
                      i18n: t('Iban Number'),
                      type: 'text',
                      required: true,
                      format: 'IR########################',
                    }}/>
                  </Col>
                </Row>
              }
              <Row className="mt-4">
                <Col>
                  <LoaderButton
                    color="success"
                    onClick={handleSubmit}
                    loading={submitting}
                    disabled={pristine || hasValidationErrors || submitting}
                    className="text-center"
                    style={{minWidth: '100px'}}>
                    {t('Save')}
                  </LoaderButton>
                  <Button
                    color="grey"
                    onClick={() =>{
                      ModalManager.close({
                        isOpen: false
                      });
                    }}
                    className="text-center mx-2"
                    style={{minWidth: '100px'}}>
                    {t('Close')}
                  </Button>
                </Col>
              </Row>
            </Form>
          );
        }}
      />
    );
  }
}

export default withTranslation()(BankAccountFormV2);
